import React from 'react'
import './Companies.css'


function Companies() {
  return (
    <section className="c-wrapper">
        <div className="paddings innerWidth flexCenter c-container">
            <img src="./image/HTML.png" alt="" />
            <img src="./image/CSS.png" alt="" />
            <img src="./image/JS.png" alt="" />
            <img src="./image/REACT.png" alt="" />
        </div>
    </section>
  )
}

export default Companies